// extracted by mini-css-extract-plugin
module.exports = {"flex":"Flex_flex__3Fp2P","column":"Flex_column__Gs-NP","inline":"Flex_inline__1joGL","start":"Flex_start__1C89F","wrap":"Flex_wrap__1EWY5"};